import { createFileRoute } from "@tanstack/react-router";
import { GroupPaymentResult } from "@/components/group-therapy/GroupPaymentResult";
import { legacyEnrollmentSearch } from "@/lib/payment-return-url";

// Legacy Monri return URL (`?status=..&enrollment=..`), kept for payment forms
// opened before the path-based URLs. Monri glues its own params onto ours with
// a second `?` and sends an `enrollment` param of its own (3-D Secure);
// legacyEnrollmentSearch cuts and dedupes them.
export const Route = createFileRoute("/grupne-terapije/payment-result")({
  validateSearch: (search: Record<string, unknown>) => legacyEnrollmentSearch(search),
  component: LegacyGroupPaymentResult,
});

function LegacyGroupPaymentResult() {
  return <GroupPaymentResult {...Route.useSearch()} />;
}
